import { render } from "./NotificationList.vue?vue&type=template&id=c7a5f6b0&scoped=true&ts=true"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"

import "./NotificationList.vue?vue&type=style&index=0&id=c7a5f6b0&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a5f6b0"]])

export default __exports__